import { useParams } from "react-router";
import React, { useState } from "react";
import { useQuery, gql } from "@apollo/client";
import Seo from "../components/seo";
import Matrix from "../components/matrix";
import Layout from "../components/layout";
import GeneralSection from "../components/newComponents/generalSection";
import Card from "../components/newComponents/card";
//import HomePageSlider from "../components/HomePageSlider";
import ImgixFluidImage from "../components/newComponents/ImgixFluidImage";
import { HandleQuery, PageData } from "../queries";

export function PageEntry()
{

    const [shownItems, setShownItems] = useState(9);
    let { slug } = useParams();

    const query_state = useQuery(PageData(slug), {fetchPolicy: 'no-cache'});
    const { complete, view } = HandleQuery(query_state);
    if(!complete) return view;
    const data = query_state.data; 
    var { entry, relatedFeedNews, relatedFeedNewsletters, relatedFeedReportsAndOtherDocuments } = data;
    const feedItems = relatedFeedNews.concat(relatedFeedNewsletters.concat(relatedFeedReportsAndOtherDocuments));  
    entry = entry[0];
  feedItems.sort(function(a, b) {
      return new Date(b.postDate).getTime() - new Date(a.postDate).getTime();
  });

  const finalImage = entry.featureImage[0] && entry.showFeatureImage ? <ImgixFluidImage attribution={entry.featureImage[0].attribution} image={entry.featureImage[0]} sizes="100vw" ar={1100/400} focalPoint={entry.featureImage[0].focalPoint}/>  : null;

  return (
    <Layout customNavLogo={entry.customNavLogo[0]} customClassName={`main page-${slug}`}>
      {/*entry.carousel && entry.carousel.length > 0 && <HomePageSlider data={entry.carousel} />*/} 
      <Seo title={entry.displayTitle} image={entry.featureImage[0]?.url} />
      <div>
        <GeneralSection className="section-inside" style={{paddingBottom: 0}}>
          <header className="section__head">
            {finalImage ? <figure className="section__head-image">{finalImage}</figure> : <></>}
            <h1 className="section__title title h2 text-gray">{entry.title}</h1>
          </header>
        </GeneralSection>
        <Matrix blocks={entry.bodyContent} />
        {feedItems.length > 0 ?
          <GeneralSection className="section-listing js-section-listing">
            <header className="section__head">
              <p className="section__title title h2 text-gray">News and insights</p>
            </header>
            <div className="boxes swiper-container js-load-more js-slider-boxes-projects">
            <ul> 
              {feedItems.map((item, i) => (
                i < shownItems ?
                  <Card key={`related-feed-${i}`} image={item.featureImage[0]} ar={2} title={item.displayTitle} subtitle={item.summary} href={`/${item.uri}`}/>
                  :
                  <></>
              ))}
            </ul>
            <div className="swiper-pagination boxes__pagination" />
          </div>
          {shownItems < feedItems.length ? 
            <div className="flex justify-center">
              <button type="button" onClick={() => {setShownItems(shownItems + 9)}} className="btn btn--green btn--icon form__btn">Load more</button>
            </div>
            :
            <></>
          }
          </GeneralSection>
          :
          <></>
        }
      </div>
    </Layout>
  );
};
